import React, { useRef } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 0 5px;
  @media (max-width: 1024px) {
    justify-content: flex-start;
  }
`

const CarouselContainer = styled.div`
  position: relative;
`

const OuterContainer = styled.div`
  overflow: hidden;
  display: block;
  position: relative;
  z-index: 2;
  scroll-behavior: smooth;
  @media (max-width: 1024px) {
    overflow-x: auto;
  }
`

const ArrowContainer = styled.div`
  position: absolute;
  bottom: 0;
  top: 0;
  align-items: center;
  left: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
`

const LeftArrow = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  z-index: 3;
  position: absolute;
  color: #ffffff;
  background-color: #333333;
  opacity: 0.3;
  transition: all 0.2s ease-in;
  &:hover {
    opacity: 1;
  }
  @media (min-width: 1025px) {
    left: 110px
  }
  @media (min-width: 1500px) {
    left: 18%;
  }
`

const RightArrow = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-right: 10px;
  position: absolute;
  z-index: 3;
  right: 0;
  color: #ffffff;
  background-color: #333333;
  opacity: 0.3;
  transition: all 0.2s ease-in;
  &:hover {
    opacity: 1;
  }
  @media (min-width: 1025px) {
    right: 110px
  }
  @media (min-width: 1500px) {
    right: 18%;
  }
`

const ArrowImage = styled.img`
  width: 46px;
  height: 40px;
`

const ARROW_LEFT_IMAGE = 'https://cld.partsimg.com/image/upload/carparts/images/left-double-arrow.png'
const ARROW_RIGHT_IMAGE = 'https://cld.partsimg.com/image/upload/carparts/images/right-double-arrow.png'
export default function SeoCarousel({ children, useCarousel, movementPoints }) {
  const containerRef = useRef()

  const performScroll = action => () => {
    if (action === 'left') {
      containerRef.current.scrollLeft -= movementPoints
    } else {
      containerRef.current.scrollLeft += movementPoints
    }
    return true
  }

  return (
    <CarouselContainer id="SeoCarousel">
      {
        useCarousel && (
          <ArrowContainer>
            <LeftArrow onClick={performScroll('left')}>
              <ArrowImage src={ARROW_LEFT_IMAGE} alt="Arrow Left" width="46" height="40" />
            </LeftArrow>
            <RightArrow onClick={performScroll('right')}>
              <ArrowImage src={ARROW_RIGHT_IMAGE} alt="Arrow Right" width="46" height="40" />
            </RightArrow>
          </ArrowContainer>
        )
      }
      <OuterContainer ref={containerRef}>
        <Container>
          { children }
        </Container>
      </OuterContainer>
    </CarouselContainer>
  )
}
